import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode;
};

const Wrapper = styled.div`
  position: relative;
  max-width: 600px;
  width: fit-content;
  margin: 0 auto;
  padding: 25px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TestimonialsAuthWrapper = ({ children }: Props) => (
  <Wrapper>{children}</Wrapper>
);
